import { render } from "./BrowserTreeItem.vue?vue&type=template&id=567c6b00&scoped=true"
import script from "./BrowserTreeItem.vue?vue&type=script&lang=js"
export * from "./BrowserTreeItem.vue?vue&type=script&lang=js"

import "./BrowserTreeItem.vue?vue&type=style&index=0&id=567c6b00&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567c6b00"]])

export default __exports__